/**
 * Main page implementation.
 *
 * @author Stanislav Kalashnik <sk@infomir.eu>
 * @license GNU GENERAL PUBLIC LICENSE Version 3
 */

'use strict';

var keys        = require('stb-keys'),
    ProgressBar = require('spa-component-progress-bar'),
    Button      = require('stb-component-button'),
    List        = require('stb-component-list'),
    Page        = require('stb-component-page'),

    config      = require('../config'),

    $playerSpaceLeftTop     = document.getElementById('playerSpaceLeftTop'),
    $playerSpaceRightTop    = document.getElementById('playerSpaceRightTop'),
    $playerSpaceRightBottom = document.getElementById('playerSpaceRightBottom'),
    $playerSpaceLeftBottom  = document.getElementById('playerSpaceLeftBottom'),
    $playerSpaceNone        = document.getElementById('playerSpaceNone'),
    $pageMain               = document.getElementById('pageMain'),
    $playerSpace            = document.getElementById('playerSpace'),
    $player                 = document.getElementById('player'),

    PLAYER = {
        stop: 0,
        play: 2,
        pause: 3
    },

    playerSpaces = {},

    playerPosition   = config.positions.rightBottom,
    progressInterval = -1,

    lastIntent       = null,
    appFocused       = false,
    repositionActive = false,
    isPlayed         = false,
    blockFocus       = false,
    page, progressBar, $pauseButton, buttonList;


playerSpaces[config.positions.leftBottom]  = $playerSpaceLeftBottom;
playerSpaces[config.positions.leftTop]     = $playerSpaceLeftTop;
playerSpaces[config.positions.rightBottom] = $playerSpaceRightBottom;
playerSpaces[config.positions.rightTop]    = $playerSpaceRightTop;
playerSpaces[config.positions.none]        = $playerSpaceNone;


function toggleReposition () {
    if ( repositionActive ) {
        // hide spaces and show player
        playerSpaces[playerPosition].classList.remove('active', 'paused', 'audio');

        $pageMain.className = 'stb-component-page active';
        $playerSpace.classList.add('active');
        buttonList.focus();
    } else {
        // show spaces and hide player
        playerSpaces[playerPosition].classList.add('active');

        if ( lastIntent && lastIntent.audio ) {
            if ( isPlayed ) {
                playerSpaces[playerPosition].classList.remove('paused');
            } else {
                playerSpaces[playerPosition].classList.add('paused');
            }
        }

        $pageMain.className = 'stb-component-page active reposition';
        $playerSpace.classList.remove('active');
        page.focus();

        if ( playerPosition === config.positions.none ) {
            $playerSpace.classList.add('active');
            $playerSpace.innerHTML = lastIntent.data.title;
        }
    }

    repositionActive = !repositionActive;
}


function setViewport ( position ) {
    var /* eslint-disable-next-line new-cap */
        videoResolution = parent.gSTB.RDir('vmode').match(/^(\d)*/g)[0],
        viewport  = config.viewports[videoResolution][screen.height][position];

    //console.log('videoResolution: ' + videoResolution);
    //console.log('viewport: ' + JSON.stringify(viewport));

    switch ( position ) {
        case config.positions.leftBottom:
            $playerSpace.innerHTML = '';
            $player.className = 'lb';
            break;

        case config.positions.rightTop:
            $playerSpace.innerHTML = '';
            $player.className = 'rt';
            break;

        case config.positions.leftTop:
            $playerSpace.innerHTML = '';
            $player.className = 'lt';
            break;

        case config.positions.rightBottom:
            $playerSpace.innerHTML = '';
            $player.className = 'rb';
            break;

        case config.positions.none:
            $player.className = 'none';
            viewport = {width: 0, height: 0, x: 0, y: 0};
            $playerSpace.classList.add('active');
            $playerSpace.innerHTML = lastIntent.data.title;
            break;
    }

    lastIntent.emit('viewport', viewport);
    playerPosition = position;

    return viewport;
}


function progressBarInit ( duration ) {
    progressBar.init({
        max: duration,
        value: 0
    });

    progressBar.show();
    buttonList.focusItem($pauseButton);
    $pauseButton.classList.remove('disabled');
    buttonList.data[1].disabled = false;
}


function disablePauseButton () {
    buttonList.focusItem(buttonList.$body.children[0]);
    buttonList.data[1].disabled = true;
    $pauseButton.classList.add('disabled');
}


page = new Page({
    $node: $pageMain
});

progressBar = new ProgressBar({
    $node: document.getElementById('progressBar'),
    parent: page
});

buttonList = new List({
    $node: document.getElementById('buttonList'),
    parent: page,
    size: 4,
    type: List.prototype.TYPE_HORIZONTAL,
    data: [
        {
            className: 'button-maximize',
            onclick: function () {
                appFocused = false;
                clearInterval(progressInterval);
                $playerSpace.classList.remove('audio');

                lastIntent.emit('maximize');
                lastIntent.close(true);

                core.call('hide');
                core.call('blur');
                lastIntent = null;
            }
        },
        // {
        //     className: 'swap',
        //     onclick: function () {
        //         lastIntent.emit('swap');
        //         if ( lastIntent.data.duration ) {
        //             progressBar.show();
        //             progressBar.init({
        //                 max: lastIntent.data.duration,
        //                 value: 0
        //             });
        //         } else {
        //             progressBar.hide();
        //         }
        //
        //         setTimeout(function () {
        //             if ( lastIntent.data.mime && lastIntent.data.mime === 'content/audio' ) {
        //                 $playerSpace.classList.add('audio');
        //                 lastIntent.audio = true;
        //             }
        //         }, 0);
        //     }
        // },
        {
            className: 'button-pause',
            onclick: function ( event ) {
                if ( isPlayed ) {
                    lastIntent.emit('pause');
                    event.$item.classList.add('paused');
                } else {
                    lastIntent.emit('resume');
                    event.$item.classList.remove('paused');
                }

                isPlayed = !isPlayed;

                if ( lastIntent && lastIntent.audio ) {
                    if ( isPlayed ) {
                        $playerSpace.classList.remove('paused');
                    } else {
                        $playerSpace.classList.add('paused');
                    }
                }
            }
        },
        {
            className: 'button-layout',
            onclick: function () {
                setTimeout(function () {
                    if ( !repositionActive ) {
                        toggleReposition();
                    }
                }, 0);
            }
        },
        {
            className: 'button-close',
            onclick: function () {
                lastIntent.emit('stop');
                core.call('hide');
                core.call('blur');
                appFocused = false;
                isPlayed = false;
                clearInterval(progressInterval);
                core.active = false;
                lastIntent = null;
            }
        }
    ],
    render: function ( $item, data ) {
        $item.button = new Button({
            $node: $item,
            className: data.className
        });
    },
    events: {
        'click:item': function ( event ) {
            event.$item.data.onclick(event);
        },
        keydown: function ( event ) {
            var isPlayPauseFocused;

            switch ( event.code ) {
                case keys.up:
                case keys.down:
                case keys.right:
                case keys.left:
                case keys.pageUp:
                case keys.pageDown:
                case keys.home:
                case keys.end:
                    // cursor move only on arrow keys
                    this.move(event.code);
                    if ( this.$focusItem.data.disabled ) {
                        this.move(event.code);
                    }
                    break;

                case keys.ok:
                    // there are some listeners
                    if ( this.events['click:item'] ) {
                        // notify listeners
                        this.emit('click:item', {$item: this.$focusItem, event: event});
                    }
                    break;

                case keys.playPause:
                    // console.log('isPlayed: ' + isPlayed);
                    // console.log('lastIntent: ' + lastIntent);
                    // console.log('buttonList.data[1].disabled: ' + buttonList.data[1].disabled);

                    if ( lastIntent && !buttonList.data[1].disabled ) {
                        isPlayPauseFocused = buttonList.$focusItem === $pauseButton;

                        if ( isPlayed ) {
                            lastIntent.emit('pause');
                            $pauseButton.className = 'stb-component-button button-pause paused ' + (isPlayPauseFocused ? 'focus' : '');
                        } else {
                            lastIntent.emit('resume');
                            $pauseButton.className = 'stb-component-button button-pause ' + (isPlayPauseFocused ? 'focus' : '');
                        }

                        isPlayed = !isPlayed;

                        if ( lastIntent.audio ) {
                            if ( isPlayed ) {
                                $playerSpace.classList.remove('paused');
                            } else {
                                $playerSpace.classList.add('paused');
                            }
                        }
                    }
                    break;
            }
        }
    }
});

$pauseButton = buttonList.$body.children[1];

page.addListener('show', function () {
    buttonList.focus();
    buttonList.focusIndex(2);
});

page.addListener('keydown', function ( event ) {
    var newPosition = null;

    if ( repositionActive ) {
        switch ( event.code ) {
            case keys.back:
            case keys.ok:
                toggleReposition();
                break;

            case keys.left:
                switch ( playerPosition ) {
                    case config.positions.rightTop:
                        newPosition = config.positions.leftTop;
                        break;

                    case config.positions.rightBottom:
                        newPosition = config.positions.leftBottom;
                        break;
                }
                break;

            case keys.right:
                switch ( playerPosition ) {
                    case config.positions.leftTop:
                        newPosition = config.positions.rightTop;
                        break;

                    case config.positions.leftBottom:
                        newPosition = config.positions.rightBottom;
                        break;
                }
                break;

            case keys.up:
                switch ( playerPosition ) {
                    case config.positions.rightBottom:
                        newPosition = config.positions.rightTop;
                        break;

                    case config.positions.leftBottom:
                        newPosition = config.positions.leftTop;
                        break;

                    case config.positions.none:
                        newPosition = config.positions.rightBottom;
                        break;
                }
                break;

            case keys.down:
                switch ( playerPosition ) {
                    case config.positions.rightBottom:
                        $player.className = 'none';
                        newPosition = config.positions.none;
                        break;

                    case config.positions.leftTop:
                        newPosition = config.positions.leftBottom;
                        break;

                    case config.positions.rightTop:
                        newPosition = config.positions.rightBottom;
                        break;
                }
                break;
        }

        if ( newPosition !== null ) {
            playerSpaces[playerPosition].classList.remove('active', 'audio', 'paused');
            setViewport(newPosition);
            playerSpaces[newPosition].classList.add('active');

            if ( lastIntent && lastIntent.audio ) {
                if ( isPlayed ) {
                    playerSpaces[newPosition].classList.remove('paused');
                } else {
                    playerSpaces[newPosition].classList.add('paused');
                }
            }
        }
    }
});

core.addListener('hide', function () {
    if ( repositionActive ) {
        toggleReposition();
    }

    $pageMain.classList.remove('active');
    appFocused = false;
});

core.addListener('intent', function ( intent, callback ) {
    if ( intent.action === 'pip' ) {
        lastIntent = intent;

        lastIntent.addListener('exit', function () {
            $pageMain.classList.remove('active');
            appFocused = false;

            core.call('hide');
            core.call('blur');
            clearInterval(progressInterval);
            lastIntent = null;
        });

        lastIntent.data.viewport = setViewport(playerPosition);
        $playerSpace.classList.remove('audio', 'paused');
        intent.audio = false;
        $pauseButton.className = 'stb-component-button button-pause';

        setTimeout(function () {
            if ( intent.mime && intent.mime === 'content/audio' ) {
                $playerSpace.classList.add('audio');
                intent.audio = true;

                // player paused
                if ( intent.data.playerState === PLAYER.pause ) {
                    $playerSpace.classList.add('paused');
                    $pauseButton.classList.add('paused');
                    isPlayed = false;
                }
            }
        }, 0);

        if ( intent.data ) {
            if ( intent.data.duration ) {
                progressBarInit(intent.data.duration);
                $pauseButton.className = 'stb-component-button button-pause focus';
            } else {
                disablePauseButton();
                progressBar.hide();

                setTimeout(function () {
                    if ( intent.data.duration ) {
                        progressBarInit(intent.data.duration);
                    }
                }, 2000);
            }
        } else {
            progressBar.hide();
        }

        $pageMain.className = 'stb-component-page';
        appFocused = false;
        isPlayed = true;
        core.call('show');
        callback(false, {});
    }
});

core.addListener('keydown:' + keys.refresh, function () {
    if ( lastIntent && !blockFocus ) {
        if ( appFocused ) {
            core.call('blur');

            if ( repositionActive ) {
                toggleReposition();
            }

            $pageMain.classList.remove('active');
            appFocused = false;
        } else {
            $pageMain.classList.add('active');
            clearInterval(progressInterval);

            if ( lastIntent.data && lastIntent.data.position ) {
                progressInterval = setInterval(function () {
                    progressBar.set(lastIntent.data.position);

                    if ( lastIntent.data.position === lastIntent.data.duration ) {
                        clearInterval(progressInterval);
                        $playerSpace.classList.add('paused');
                        $pauseButton.classList.add('paused');
                        disablePauseButton();
                        lastIntent.emit('pause');
                    }
                }, 900);
            } else {
                progressBar.hide();
            }

            core.call('show');
            core.call('focus');
            appFocused = true;
        }
    }
});

core.addListener('keydown:' + keys.web, function () {
    // TODO: remove this hardcore, add into core osd overlay logic
    core.call('hide');
    appFocused = false;
});

// public
module.exports = page;
